module.exports = __webpack_public_path__ + "static/media/58_block-filter_NBM.7b4539cf.png";